export enum FileState {
  New = 'New',
  Existing = 'Existing'
}
